
import { Options, Vue } from "vue-class-component";
import { isDefined } from "@/utils";
import { QrcodeCanvas } from "qrcode.vue";

@Options({
  components: { QrcodeCanvas }
})
export default class QrCodeDialog extends Vue {

  private isOpen: boolean = false;
  private qrCodeData: any;

  constructor(props) {
    super(props);
  }


  public openDialog(qrCodeData: any): void {
    this.qrCodeData = qrCodeData;
    this.addClickListener();
    this.isOpen = true;
  }

  public closeDialog(event: Event): void {
    event.stopImmediatePropagation();
    this.removeClickListener();
    this.isOpen = false;
  }

  private addClickListener() {
    window.addEventListener("click", this.onClick);
  }

  private removeClickListener() {
    window.removeEventListener("click", this.onClick);
  }

  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog(event);
        }
      }
    }
  }

}
